export const environment = {
  production: false,
  baseUrl: '/',
  baseUrlUI: '/'
};

